import React, { FunctionComponent, MutableRefObject } from 'react';

import { CustomFieldValue } from '@api/v4/assets/customFieldTypes';
import { ListDropdown, ListOption } from '@components/library/dropdown/index';
import { CustomFieldKeyValuesEntry } from '@components/asset/modal/tabs/edit/EditTabTypes';

interface SingleValueRestrictedProps {
  currValues: ListOption[];
  existingCustomFieldMap: CustomFieldKeyValuesEntry;
  handleUpdate: (customFieldValue: CustomFieldValue, customFieldRequired?: boolean) => void;
  options: ListOption[];
  required: boolean;
  overflowParentRef?: MutableRefObject<HTMLElement>;
}

export const SingleValueRestricted: FunctionComponent<SingleValueRestrictedProps> = ({
  currValues,
  existingCustomFieldMap,
  handleUpdate,
  options,
  overflowParentRef,
  required
}) => {
  const value = currValues && currValues.length > 0 ? currValues[0] : undefined;
  const touched = existingCustomFieldMap?.customFieldTouched;
  const showRequired = required && touched && !!value === false;

  return (
    <ListDropdown
      error={showRequired && bfTranslate('Value required')}
      onChange={(listOption: ListOption): void => {
        let customFieldValueId = '';
        if (existingCustomFieldMap?.customFieldValues.length > 0) {
          customFieldValueId = existingCustomFieldMap?.customFieldValues[0].key;
        }
        handleUpdate({ key: customFieldValueId, value: listOption.value as string }, required);
      }}
      options={options}
      overflowParentRef={overflowParentRef}
      placeholder={bfTranslate('Select value')}
      searchable
      value={value}
    />
  );
};
